import { Inject, Injectable } from '@angular/core';
import {
  APP_ENVIRONMENT,
  AppEnvironment,
  MfeAppConfig
} from 'src/app/app.environment';
import { bootstrapData } from 'src/bootstrap/bootstrap-data';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  constructor(@Inject(APP_ENVIRONMENT) private environment: AppEnvironment) {}

  getApps(): Record<string, MfeAppConfig> {
    return this.environment.apps;
  }

  getAppsArray(): MfeAppConfig[] {
    return Object.values(this.environment.apps);
  }

  getLoadedApps(): MfeAppConfig[] {
    return this.getAppsArray().filter(
      (x) =>
        !!x?.path && bootstrapData.mfeStates[x.path] !== 'error-loading-module'
    );
  }

  getAppEntries(): [string, MfeAppConfig][] {
    return Object.entries(this.environment.apps);
  }

  getAppByKey(key: string): MfeAppConfig | undefined {
    return this.environment.apps[key];
  }

  getDefaultApp(): MfeAppConfig {
    const defaultApp = this.findApp((app) => app.isDefaultApp);
    if (!defaultApp) {
      throw new Error('No default app found');
    }
    return defaultApp;
  }

  getDefaultAppKey(): string | undefined {
    return Object.keys(this.environment.apps).find(
      (key) => this.environment.apps[key].isDefaultApp
    );
  }

  get<T extends keyof AppEnvironment>(key: T): AppEnvironment[T] | undefined {
    const value = this.environment[key];
    if (value === undefined) {
      console.warn(`Key "${key}" not found in environment.`);
    }
    return value;
  }

  private filterApps(
    predicate: (app: MfeAppConfig) => boolean
  ): MfeAppConfig[] {
    return Object.values(this.environment.apps).filter(predicate);
  }

  private findApp(
    predicate: (app: MfeAppConfig) => boolean
  ): MfeAppConfig | undefined {
    return Object.values(this.environment.apps).find(predicate);
  }
}
